import { useTranslation } from 'react-i18next';
import type { FileState } from '../../lib/types.ts';
import { shortDate } from './format.ts';

/**
 * Ось файла (спека §2): «в хранилище» / «освобождён {дата}».
 * При status='absent' файла ещё нет (клип не отрендерен, фильм качается) —
 * это НЕ потеря, поэтому чип не рисуем вовсе: состояние рендера показывает
 * статусный чип самой сущности.
 */
export function FileChip({ file }: { file: FileState }) {
  const { t } = useTranslation();

  if (file.status === 'available') {
    return <span className="chip ok">{t('archive.file.stored')}</span>;
  }
  if (file.status === 'freed') {
    return <span className="chip warn">{t('archive.file.freed', { date: shortDate(file.freedAt) })}</span>;
  }
  return null;
}
